import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Login/Login.css"; // نفس التنسيق اللي استخدمته

export default function BurialRequestsList() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchRequests = async () => {
    try {
      const { data } = await axios.get(
        "https://cemetery-management.vercel.app/api/burial-requests"
      );
      setRequests(data);
    } catch (err) {
      setError("فشل في تحميل الطلبات.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleAction = async (id, action) => {
    try {
      const token = localStorage.getItem("userToken");
      await axios.put(
        `https://cemetery-management.vercel.app/api/burial-requests/${id}/${action}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRequests(requests.filter((req) => req._id !== id));
    } catch (err) {
      alert("حدث خطأ أثناء تنفيذ العملية.");
    }
  };

  return (
    <div className="login-container">
      <h2>طلبات الدفن</h2>
      {loading && <p>جاري التحميل...</p>}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && requests.length === 0 && (
        <p className="text-center">لا توجد طلبات حالياً.</p>
      )}

      {!loading &&
        requests.map((req) => (
          <div key={req._id} className="alert alert-light border mb-3">
            <p>
              <strong>اسم المتوفي:</strong> {req.name}
            </p>
            <p>
              <strong>تاريخ الدفن:</strong>{" "}
              {new Date(req.burialDate).toLocaleDateString("ar-EG")}
            </p>
            <p>
              <strong>رقم المقبرة:</strong> {req.graveNumber}
            </p>

            <button
              onClick={() => handleAction(req._id, "accept")}
              className="btn btn-success btn-sm me-2"
            >
              موافقة
            </button>
            <button
              onClick={() => handleAction(req._id, "reject")}
              className="btn btn-danger btn-sm"
            >
              رفض
            </button>
          </div>
        ))}
    </div>
  );
}
